export default "__VITE_ASSET__P$hHn$_s__"